import { createApi } from '@stilingue/st-auth-utils';
import Service from './Service';

class SendGridService extends Service {
  constructor(api) {
    super(api, {});
  }

  sendMail(params) {
    params.templateId = process.env.VUE_APP_STUDIO_TRIAL_TEMPLATE_ID;

    return this.api.post({ ...params, url: 'emails/send' });
  }
}

const api = createApi(`email-service-dispatcher/${process.env.VUE_APP_EMAIL_SERVICE_VERSION}/`, process.env.VUE_APP_BACKEND_URL, {
  authNotFound: () => true,
  error401Handler: (error) => {
    return Promise.reject(error);
  },
});
export default new SendGridService(api);
